import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Box, Typography } from '@material-ui/core';

import InfoCard from '~/components/InfoCard';
import LocaleMessage from '~/components/LocaleMessage';

import CleaningReportChartsCard, {
    STATUS_FILTER as CHART_PIE_STATUS,
} from '../CleaningReportsDashboard/CleaningReportChartsCard';
import CleaningReportTasksTablePagination from '../CleaningReportsDashboard/CleaningReportTasksTablePagination';
import CleaningTaskTableHead from './CleaningTaskTableHead';
import CleaningTaskTableRows from './CleaningTaskTableRows';

export default function CleaningReportPluginspaceFullscreen({
    classes,
    loadError,
    apiError,
    robots_errors,
    total,
    totalCleanFormatted,
    totalArea,
    robotsQueried,
    cardColor,
    graphColor,
    pieSegmentColors,
    list,
    localeCode,
    periodDates,
    fsAreaChartHeight,
    scrollToCleaningTable,
    cleaningTableRef,
    tableRowsForDisplay,
    onRowClick,
    tasksTablePage,
    tasksTableRowsPerPage,
    tasksTableTotalCount,
    onTasksTablePageChange,
    onTasksTableRowsPerPageChange,
}) {
    return (
        <Box className={classes.fsRoot}>
            {(loadError || apiError) && (
                <Typography component="div" className={classes.fsErrorLine}>
                    <LocaleMessage msg="page.robots.cleaning_report.fetch_failed" />
                    {apiError && apiError.error ? ` — ${apiError.error}` : ''}
                </Typography>
            )}
            {robots_errors && robots_errors.length > 0 ? (
                <Typography component="div" className={classes.fsWarnLine}>
                    <FormattedMessage
                        id="page.robots.cleaning_report.live.fs_partial_robots"
                        values={{
                            count: robots_errors.length,
                        }}
                    />
                </Typography>
            ) : null}
            <div className={`${classes.fsKpiGrid} ${classes.fsSurface}`}>
                <InfoCard
                    data={{
                        title: String(total),
                        subTitle: (
                            <LocaleMessage msg="page.robots.cleaning_report.card_total_records" />
                        ),
                    }}
                    color={cardColor}
                    icon="format-list-bulleted"
                    onClick={scrollToCleaningTable}
                />
                <InfoCard
                    data={{
                        title: totalCleanFormatted,
                        subTitle: (
                            <LocaleMessage msg="page.robots.cleaning_report.card_clean_time" />
                        ),
                    }}
                    color={cardColor}
                    icon="timer"
                />
                <InfoCard
                    data={{
                        title: `${totalArea} m²`,
                        subTitle: (
                            <LocaleMessage msg="page.robots.cleaning_report.card_clean_area" />
                        ),
                    }}
                    color={cardColor}
                    icon="border-style"
                />
                <InfoCard
                    data={{
                        title: String(robotsQueried),
                        subTitle: (
                            <LocaleMessage msg="page.robots.cleaning_report.live.robots_queried" />
                        ),
                    }}
                    color={cardColor}
                    icon="android"
                />
            </div>
            <Box className={`${classes.fsChartsSlot} ${classes.fsSurface}`}>
                <CleaningReportChartsCard
                    key="cleaning-report-fs-charts"
                    compact
                    initialPieField={CHART_PIE_STATUS}
                    areaChartHeight={fsAreaChartHeight}
                    cardColor={graphColor}
                    chartColor={cardColor}
                    pieSegmentColors={pieSegmentColors}
                    list={list}
                    localeCode={localeCode}
                    periodDates={periodDates}
                />
            </Box>
            <Box
                ref={cleaningTableRef}
                id="cleaning-report-table-pluginspace"
                className={`${classes.fsTableSlot} ${classes.fsSurface}`}
            >
                <div
                    className={`jr-card jr-card-widget ${classes.fsTableCard}`}
                >
                    <Typography
                        variant="subtitle2"
                        component="h2"
                        className={classes.fsTableTitle}
                    >
                        <LocaleMessage msg="page.robots.cleaning_report.live.table_title" />
                    </Typography>
                    <div className={classes.fsTableScroll}>
                        <table className="table mb-0">
                            <CleaningTaskTableHead />
                            <tbody>
                                <CleaningTaskTableRows
                                    rows={tableRowsForDisplay}
                                    localeCode={localeCode}
                                    onRowClick={onRowClick}
                                />
                            </tbody>
                        </table>
                        <CleaningReportTasksTablePagination
                            count={tasksTableTotalCount}
                            page={tasksTablePage}
                            rowsPerPage={tasksTableRowsPerPage}
                            onPageChange={onTasksTablePageChange}
                            onRowsPerPageChange={onTasksTableRowsPerPageChange}
                        />
                    </div>
                </div>
            </Box>
        </Box>
    );
}
